import React from 'react';
import { useNavigate } from 'react-router-dom';
import { 
    ArrowLeft,
    ExternalLink,
    FileText,
    Globe,
    Phone,
    Shield
} from 'lucide-react';
import { Card, CardContent, CardHeader, CardTitle } from '../components/ui/card';
import { Button } from '../components/ui/button';

const links = [
    {
        category: 'SES Resources',
        items: [
            { name: 'SES Queensland', url: 'https://www.ses.qld.gov.au', icon: Shield },
            { name: 'SES Volunteer Portal', url: 'https://volunteer.ses.qld.gov.au', icon: Globe },
            { name: 'Emergency Contacts', url: 'tel:132500', icon: Phone },
        ]
    },
    {
        category: 'Training',
        items: [
            { name: 'AIIMS Guidelines', url: 'https://www.aidr.org.au/aiims', icon: FileText },
            { name: 'Safe Work Australia', url: 'https://www.safeworkaustralia.gov.au', icon: Shield },
        ]
    },
    {
        category: 'Weather & Conditions',
        items: [
            { name: 'Bureau of Meteorology', url: 'http://www.bom.gov.au', icon: Globe },
            { name: 'QLD Flood Warnings', url: 'http://www.bom.gov.au/qld/flood', icon: Globe },
        ]
    }
];

export default function LinksPage() {
    const navigate = useNavigate();
    
    const openLink = (url) => {
        window.open(url, '_blank', 'noopener,noreferrer');
    };
    
    return (
        <div className="min-h-screen bg-background" data-testid="links-page">
            {/* Header */}
            <header className="bg-card border-b border-border sticky top-0 z-30">
                <div className="flex items-center h-14 px-4">
                    <Button variant="ghost" size="icon" onClick={() => navigate('/portal')} data-testid="back-btn">
                        <ArrowLeft className="w-5 h-5" />
                    </Button>
                    <h1 className="text-lg font-semibold ml-2">Links</h1>
                </div>
            </header>
            
            <div className="p-4 space-y-6 pb-20">
                {links.map((section) => (
                    <div key={section.category}>
                        <h2 className="font-semibold text-sm text-muted-foreground uppercase tracking-wider mb-3">
                            {section.category}
                        </h2>
                        <Card>
                            <CardContent className="p-0">
                                {section.items.map((link, index) => (
                                    <button
                                        key={link.name}
                                        onClick={() => openLink(link.url)}
                                        className={`w-full flex items-center justify-between p-4 hover:bg-muted/50 transition-colors ${
                                            index < section.items.length - 1 ? 'border-b border-border' : ''
                                        }`}
                                    >
                                        <div className="flex items-center gap-3">
                                            <link.icon className="w-5 h-5 text-muted-foreground" />
                                            <span className="font-medium">{link.name}</span>
                                        </div>
                                        <ExternalLink className="w-4 h-4 text-muted-foreground" />
                                    </button>
                                ))}
                            </CardContent>
                        </Card>
                    </div>
                ))}
            </div>
        </div>
    );
}
